import React, { useRef, useState } from 'react';
import { applyCreativeRetry, campaignErrorMessage, checkCreativeAssignment, reviewCreativeRetry } from '../api/adpilotApi';

export default function CreativeRecovery({ launch, onChanged }) {
  const [review, setReview] = useState(null), [busy, setBusy] = useState(false), [error, setError] = useState(null);
  const inFlight = useRef(false);
  if (!launch?.creative_recovery_available) return null;
  const pending = busy || launch.creative_status === 'assigning';
  const run = async work => {
    if (inFlight.current) return;
    inFlight.current = true; setBusy(true); setError(null);
    try { await work(); } catch (err) { setError(campaignErrorMessage(err)); }
    finally { inFlight.current = false; setBusy(false); }
  };
  return <section className="creative-package-review" aria-label="Recover ad assignment">
    <h3>Check and complete your ads</h3>
    <p>Check the current results first. You can then review any ads that were never attempted. Previously attempted ads will not be resent.</p>
    {error && <p className="notice notice-error" role="alert">{error}</p>}
    {pending && <p role="status">{launch.creative_action === 'resume' ? 'Creating the approved remaining ads…' : 'Checking assignment…'}</p>}
    {!review ? <div className="form-actions">
      <button type="button" className="btn btn-secondary" disabled={pending} onClick={() => run(async () => { await onChanged(await checkCreativeAssignment(launch.id)); })}>Check current ad results</button>
      <button type="button" className="btn btn-secondary" disabled={pending} onClick={() => run(async () => setReview(await reviewCreativeRetry(launch.id)))}>Review unattempted ads</button>
    </div> : <>
      <h4>Review {review.summary.ads.length} remaining ads</h4>
      <p>{review.summary.campaign_name} · Account {review.summary.ad_account_id}</p>
      <p>{review.summary.confirmed_ads} of {review.summary.expected_ads} approved ads already confirmed.</p>
      {review.summary.ads.map(ad => <section key={`${ad.group}/${ad.ad_id}`}>
        <h4>{ad.group} / {ad.ad_id}</h4><p>{ad.lead_gen_form_id ? `Instant Form · ${ad.lead_gen_form_id}` : ad.final_url}</p>
        {ad.copy && <><p>{ad.name}</p><p>{ad.copy.primary_text}</p><p>{ad.copy.headline}</p><p>{ad.copy.description}</p><p>{ad.copy.call_to_action}</p><ul>{(ad.source_files || []).map((file, i) => <li key={i}>{file}</li>)}</ul></>}
        {(ad.path1 || ad.path2) && <p>Display path: {[ad.path1, ad.path2].filter(Boolean).join('/')}</p>}
        <ul>{(ad.headlines || []).map((text, i) => <li key={i}>{text}</li>)}</ul>
        <ul>{(ad.descriptions || []).map((text, i) => <li key={i}>{text}</li>)}</ul>
      </section>)}
      <p>{review.summary.note}</p>
      <div className="form-actions"><button type="button" className="btn btn-primary" disabled={pending} onClick={() => run(async () => {
        const result = await applyCreativeRetry(launch.id, review.id); setReview(null); await onChanged(result);
      })}>Approve and create remaining ads</button>
      <button type="button" className="btn btn-secondary" disabled={busy} onClick={() => setReview(null)}>Cancel review</button></div>
    </>}
  </section>;
}
